module.exports = "/_next/static/images/text-blue-num-3-4623d23b.png";